import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from '../../../../../shared/services/api.service';
import { feedbackquestions } from '../../../../../shared/models/feedbackquestions';
import { Router } from '@angular/router';
import { MSMEEventEnrollmentModel } from '../../../../../shared/models/MSMEEventEnrollmentModel';
import { MSMEGetEventDetailsForFeedbackFormModel } from '../../../../../shared/models/MSMEGetEventDetailsForFeedbackForm';

@Component({
  selector: 'app-feedbackform',
  templateUrl: './feedbackform.component.html',
  styleUrl: './feedbackform.component.css'
})
export class FeedbackformComponent implements OnInit {
  list1 = [];
  usr_obj = this.list1;
  feedbackquestions: any = [];
  sections: { [key: string]: feedbackquestions[] } = {};
  options: string[] = ['Excellent', 'Good', 'Neutral', 'Poor'];
  profileForm: FormGroup;
  MsmeId = sessionStorage.getItem("userId");
  eventid = sessionStorage.getItem("EventId");
  enrollmentId = sessionStorage.getItem("EnrollmentId");
  msmeUserName = sessionStorage.getItem('msMeUserName');
  eventObj!: MSMEEventEnrollmentModel;
  udyamusr_obj!: MSMEGetEventDetailsForFeedbackFormModel;
  constructor(private fb: FormBuilder, private toastr: ToastrService, private apiService: ApiService,
    private router: Router,) {

    this.profileForm = this.fb.group({
     
      eventId: new FormControl(null),
      eventDate: new FormControl(null),
      time: new FormControl(null),
      udyamRegistrationNumber: new FormControl(null),
      nameOfOrganisation: new FormControl(null),
      interventionName: new FormControl(null),
      interestName: new FormControl(null),
     
      name: new FormControl(null),
      nameOfEnterprise: new FormControl(null),
      typeOfOrganization: new FormControl(null),
      ownersMobileNumber: new FormControl(null),
      gender: new FormControl(null),
      sector: new FormControl(null),
      socialCategory: new FormControl(null),
      email: new FormControl(null),
      ownersaddress: new FormControl(null),
      officialAddressOfEnterprise: new FormControl(null),
      stateName: new FormControl(null),
      districtName: new FormControl(null),
      block: new FormControl(null),
      city:  new FormControl(null),
      pin: new FormControl(null), 
     
      participantName: new FormControl(null),
      mobileNumber: new FormControl(null),
      emailId: new FormControl(null),
      enrollmentId: new FormControl(null),
      designation: new FormControl(null),

      //tdistrict: new FormControl(null, [Validators.required]),
      //town: new FormControl(null, [Validators.required]),
      //eventName: new FormControl(null, [Validators.required]),
      //trainerName: new FormControl(null, [Validators.required]),
      declarationchk: new FormControl(false, [Validators.requiredTrue]),
      //toolkitShared: new FormControl(''), // Control for 'Was any toolkit shared?' question
      //otherQuestion: new FormControl(''),  // General control for other questions
    });

   
  }
  ngOnInit(): void {

    this.getAllQuestions();
    this.LoadEventDetails();
  
  }
  bindfeilds() {
    // Dynamically create form controls based on the sections and questions
    //for (const section of Object.keys(this.sections)) {
    //  this.sections[section].forEach((question: any) => {
    //    const controlName = 'question' + question.questionId;  // Generate unique control name
    //    // Dynamically create and add a FormControl
    //    this.profileForm.controls[controlName] = new FormControl('', Validators.required);
    //  });
    //}
    //for (const section of Object.keys(this.sections)) {
    //  this.sections[section].forEach((question: any) => {
    //    // Dynamically add form controls for each question
    //    const controlName = 'question' + question.questionId;  // Generate unique control name
    //    this.profileForm.addControl(
    //      controlName,
    //      new FormControl('', Validators.required) // Add your validators here
    //    );
    //  });
    //}
    const group: any = { ...this.profileForm.controls };  // Clone existing controls

    // Loop through sections and questions to dynamically create form controls
    for (const section of Object.keys(this.sections)) {
      this.sections[section].forEach((question: any) => {
        const controlName = question.questionId;  // Generate unique control name
        // Dynamically create and add a FormControl
        //group[controlName] = new FormControl('', Validators.required);
        this.profileForm.addControl(
              controlName,
              new FormControl('', Validators.required) // Add your validators here
          );
        //this.profileForm = this.fb.group(group);
      });
    }

    // Reinitialize the form with both static and dynamic controls
    //this.profileForm = this.fb.group(group);
   
}


  getAllQuestions() {
    this.apiService.getRequest(API_ENDPOINTS.getfeedbackquestions).subscribe(result => {
      this.feedbackquestions = result.data;
      this.groupQuestionsBySection(this.feedbackquestions);
      this.bindfeilds();
      
    });
  }

  groupQuestionsBySection(questions: feedbackquestions[]): void {
    questions.forEach((question: any )=> {
      if (!this.sections[question.questionType]) {
        this.sections[question.questionType] = [];
      }
      this.sections[question.questionType].push(question);
    });
  }

  getSectionKeys(): string[] {
    return Object.keys(this.sections);
  }

  onSubmit(): void {
    if (this.profileForm.valid) {
      
      const msmeQuestionAnswerMapping = Object.keys(this.profileForm.value).map(key => {
        const questionId = parseInt(key, 10); 
        if (isNaN(questionId)) {
          console.error(`Invalid QuestionId: ${key}`); 
          return null; 
        }

        return {
          QuestionId: questionId,  
          Answer: this.profileForm.value[key]  
        };
      }).filter(mapping => mapping !== null); 
      
      const dtoFeedBackQuestionAnswer = {
        MsmeId: this.MsmeId, 
        //TrainingId: 'MSME_MH-02-0000043_01',
        EventId :this.eventid ,
        msmeFeedbackQuestionAnswerMapping: msmeQuestionAnswerMapping,
        EnrollmentId: this.enrollmentId
      };
      
      this.apiService.postRequest(API_ENDPOINTS.savemsmefeedbackquestionanswer, dtoFeedBackQuestionAnswer)
        .subscribe(response => {
          if (response) {
            this.toastr.success("Feedback submitted successfully.");
          }
        });

    } else {
      this.toastr.error("Please fill all required fields.");
    }
  }
  

  onPressBack() {
    this.router.navigate(['/vieweventlist']);
  }

  LoadEventDetails() {
    const dtoFeedbackFormFields = {
      UdyamRegistrationNumber : this.msmeUserName,
      EventId : this.eventid,
      EnrollmentId: this.enrollmentId
    }    
    this.apiService.getRequest(API_ENDPOINTS.geteventdetailsforfeedbackform, dtoFeedbackFormFields).subscribe(
        (result: MSMEGetEventDetailsForFeedbackFormModel) => {
        if (result.status) {
          this.profileForm.patchValue(result.list1[0]);
          this.profileForm.patchValue(result.list2[0]);
          this.profileForm.patchValue(result.list3[0]);
          //this.profileForm.patchValue(result.list4[0]);
            this.udyamusr_obj = {
              status: result.status,
              message: result.message,
              list1: result.list1.length > 0 ? [result.list1[0]] : [],
              list2: result.list2,
              list3: result.list3
              //list4: result.list4
          };
          this.disableFormControls();
          }
        });    
  }

  disableFormControls() {
    const controlsToDisable = [
      'eventId',
      'eventDate',
      'time',
      'udyamRegistrationNumber',
      'nameOfOrganisation',
      'interventionName',
      'interestName',
      'name',
      'nameOfEnterprise',
      'typeOfOrganization',
      'ownersMobileNumber',
      'gender',
      'sector',
      'socialCategory',
      'email',
      'ownersaddress',
      'officialAddressOfEnterprise',
      'stateName',
      'districtName',
      'block',
      'city',
      'pin',
      'participantName',
      'mobileNumber',
      'emailId',
      'enrollmentId',
      'designation'
    ];

    controlsToDisable.forEach(controlName => {
      const control = this.profileForm.get(controlName);
      if (control) {
        control.disable();
      }
    });
  }
}
